import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { AiScheduleInfo } from '../../types/IAiConversation';
import CalendarIcon from '../icons/CalendarIcon';

const NEXT_FORMAT = 'ddd, MMM D · h:mm a';

interface IProps {
  schedule: AiScheduleInfo;
}

// A schedule the assistant just saved; the Schedules page is where it is managed.
const ScheduleChip = ({ schedule }: IProps) => {
  const next = schedule.nextRunUtc
    ? moment.utc(schedule.nextRunUtc).local().format(NEXT_FORMAT)
    : null;
  const meta = next ? `${schedule.runs} · next ${next}` : schedule.runs;

  return (
    <Link
      to="/schedules"
      className="chat-file chat-file--schedule"
      title="Open the Schedules page"
      data-track="ai_schedule_opened"
    >
      <span className="chat-file-kind chat-file-kind--schedule">
        <CalendarIcon />
      </span>
      <span className="chat-file-name">Schedule saved: {schedule.name}</span>
      <span className="chat-file-meta">{meta}</span>
    </Link>
  );
};

export default ScheduleChip;
